import type {PreparedBlock} from '@github-ui/taillights-worker/document'
import type {CSSProperties, ReactNode} from 'react'

export type TaillightRenderer = 'bitmap' | 'css'

export const taillightPlacementProperties = [
  'position',
  'inset',
  'insetBlock',
  'insetBlockStart',
  'insetBlockEnd',
  'insetInline',
  'insetInlineStart',
  'insetInlineEnd',
  'top',
  'right',
  'bottom',
  'left',
  'zIndex',
  'margin',
  'marginBlock',
  'marginBlockStart',
  'marginBlockEnd',
  'marginInline',
  'marginInlineStart',
  'marginInlineEnd',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
] as const

export type TaillightPlacementStyle = Pick<CSSProperties, (typeof taillightPlacementProperties)[number]>

export type TaillightProps = {
  block: PreparedBlock
  renderer?: TaillightRenderer
  inert?: boolean
  isSelectable?: boolean
  hidePaint?: boolean
  children?: ReactNode
  'aria-label'?: string
  className?: string
  style?: TaillightPlacementStyle
  onRenderError?: (error: Error) => void
}
